/**
 * Real photographs from A Learning Lab programmes (files live in /public).
 * Keep alt text descriptive of what is visible; width and height are the intrinsic file sizes (avoid layout shift).
 */
const base = process.env.PUBLIC_URL || "";

export const PHOTOS = {
  campus: {
    src: `${base}/explore.JPG`,
    alt: "Students walking together through a historic university campus",
    width: 480,
    height: 558,
  },
  classroom: {
    src: `${base}/explore-2.JPG`,
    alt: "Students taking notes during a lecture in a university classroom",
    width: 480,
    height: 622,
  },
  instructor: {
    src: `${base}/Instructor.JPG`,
    alt: "A medical student teaching in front of a whiteboard",
    width: 1024,
    height: 1140,
  },
  speaker: {
    src: `${base}/Speaker.JPG`,
    alt: "A guest speaker presenting to students",
    width: 1024,
    height: 1070,
  },
  avenue: {
    src: `${base}/AWA-hero.jpg`,
    alt: "A group of students walking down a tree-lined avenue towards a university building",
    width: 1920,
    height: 1285,
  },
  groupStudy: {
    src: `${base}/moments/group-study.jpg`,
    alt: "Students working together on laptops and a whiteboard",
    width: 1000,
    height: 545,
  },
  medicalTeam: {
    src: `${base}/moments/medical-team.webp`,
    alt: "Healthcare students reviewing notes together",
    width: 491,
    height: 325,
  },
  debate: {
    src: `${base}/moments/student-debate.webp`,
    alt: "Students in school blazers smiling around a table",
    width: 491,
    height: 325,
  },
};

/** Home "Moments of Growth" slider: photos scroll left in an endless loop. */
export const MOMENTS = {
  title: "Moments of Growth",
  highlight: "Growth",
  photos: ["campus", "groupStudy", "speaker", "medicalTeam", "classroom", "debate", "instructor", "avenue"],
};
